<lucide-icon [img]="icon()"></lucide-icon>
